import React, { useEffect } from 'react';
import { FileUpload, SpaceBetween, Container } from '@amzn/awsui-components-react';
import FormField from '@amzn/awsui-components-react/polaris/form-field';
import Button from '@amzn/awsui-components-react/polaris/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Max file size is 5MB
const MAX_CSV_FILE_SIZE = 5000000;

export function AmbassadorBulkUpdateForm() {
  const [selectedFiles, setSelectedFiles] = React.useState<File[] | null>(null);
  const [fileErrors, setFileErrors] = React.useState<(string | null)[] | undefined>(undefined);
  const navigate = useNavigate();
  const { t } = useTranslation(['ambassadors', 'translation']);

  useEffect(() => {
    if (selectedFiles?.length && selectedFiles[0].size > MAX_CSV_FILE_SIZE) {
      setFileErrors([t('bulkUpdate.ambassadors.CSVSizeError')]);
    } else {
      setFileErrors(undefined);
    }
  }, [selectedFiles, setFileErrors, t]);

  const validFilesSelected =
    selectedFiles !== null &&
    !selectedFiles.find((file) => !file.name.endsWith('.csv')) &&
    (!fileErrors || !fileErrors.length);

  return (
    <>
      <SpaceBetween direction="vertical" size="m">
        <Container>
          <SpaceBetween direction="vertical" size="m">
            <FormField label={t('bulkUpdate.ambassadors.uploadCSV')}>
              <FileUpload
                onChange={({ detail }) => setSelectedFiles(detail.value)}
                multiple={false}
                value={selectedFiles || []}
                fileErrors={fileErrors}
                accept=".csv"
                showFileLastModified
                showFileSize
                showFileThumbnail
                i18nStrings={{
                  uploadButtonText: (e) => t('bulkUpdate.ambassadors.chooseFiles'),
                  dropzoneText: (e) => t('bulkUpdate.dropFile'),
                  removeFileAriaLabel: (e) => t('bulkUpdate.removeFile'),
                  limitShowFewer: t('bulkUpdate.showFewer'),
                  limitShowMore: t('bulkUpdate.showMore'),
                  errorIconAriaLabel: t('bulkUpdate.error'),
                }}
              />
              <div style={{ color: '#656871' }}>
                <div>{t('bulkUpdate.ambassadors.onlyCSV')}</div>
                <div>{t('bulkUpdate.ambassadors.CSVSize')}</div>
              </div>
            </FormField>
          </SpaceBetween>
        </Container>
        <div style={{ float: 'right' }}>
          <Button
            variant="primary"
            disabled={!validFilesSelected}
            loading={false}
            onClick={() => {
              if (selectedFiles && selectedFiles.length > 0) {
                const filename = selectedFiles[0].name;
                navigate(`/ambassadors/bulk-update?filename=${encodeURIComponent(filename)}`);
              }
            }}
          >
            {t('bulkUpdate.ambassadors.next')}
          </Button>
        </div>
      </SpaceBetween>
    </>
  );
}
